module.exports = __webpack_public_path__ + "static/media/button-play.71980135.svg";